import React, { useContext, useEffect, useMemo, useState } from 'react';
import { Breadcrumb, Button, Form, Modal, OverlayTrigger, Table, Dropdown } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { BiChevronDown, BiDotsHorizontalRounded, BiChevronUp, BiCopy, BiImport, BiInfoCircle, BiPencil, BiPlus, BiPlusCircle, BiSearch, BiSolidPencil, BiSolidPlusCircle, BiSolidTrash, BiSolidUserPlus, BiTrash } from "react-icons/bi";
import { useNavigate } from 'react-router-dom';
import { BsChevronRight } from "react-icons/bs"
import { toast } from "react-toastify";
import { EventContext, LoaderContext } from '../../../../App';
import ConfirmationModal from '../../../../components/ConfirmationModal/ConfirmationModal';
import { EventType, LS_AUTHORITY_KEY, LS_REGULATION_SELECTED_KEY, LS_SELECTED_MAT_ISSUE_YEAR, currentYear, startYear } from '../../../../core/constants/common';
import { useCallbackPrompt } from '../../../../core/hooks/useCallbackPrompt';
import StakehodlerLibraryService from '../../../../core/service/StakeholderLibraryService';
import Utils from '../../../../core/utilities/Utils';
import Validations from '../../../../core/utilities/Validations';
import assessment_pic from "../../../../images/Assessment.png";
import './MaterialityAssessment.scss';
import useHasPermission from '../../../../core/hooks/useHasPermission';

const Stakeholders = ({ t }) => {

    // All hooks must be called at the top level, before any loops or conditional code
    const { setLoaderDisplay } = useContext(LoaderContext);
    const { setEvent } = useContext(EventContext);
    const navigate = useNavigate();
    const { hasDoubleMaterialityUpdatePermission } = useHasPermission();



    const [validated, setValidated] = useState(false);
    const [validatedGroup, setValidatedGroup] = useState(false);
    const [stakeholders, setStakeholders] = useState([]);
    const [stakeholderVisibility, setStakeholderVisibility] = useState({});
    const [stakeholderDetails, setStakeholderDetails] = useState({});
    const [stakeholderDetailsMain, setStakeholderDetailsMain] = useState({});

    // Financial Materiality state
    const [financialMaterialityEnabled, setFinancialMaterialityEnabled] = useState(true);

    const [formFields, setFormFields] = useState([
        { name: "", email: "" },
    ]);
    const [showAddCategory, setShowAddCategory] = useState(false);
    const handleAddCategoryClose = () => { setShowAddCategory(false); setUpdateType(''); setCategoryDetails({ parentId: null, name: '', type: '', children: [] }) };
    const handleAddCategoryShow = () => {
        setShowAddCategory(true);
        // Set Financial Materiality toggle to On by default for new categories
        if (!categoryDetails.id) {
            setFinancialMaterialityEnabled(true);
        }
    };

    const [showAddGroup, setShowAddGroup] = useState(false);
    const handleAddGroupClose = () => { setShowAddGroup(false); setUpdateType(''); setGroupDetails({ parentId: null, name: '', type: '', weightage: '' }); setValidatedGroup(false); };
    const handleAddGroupShow = () => setShowAddGroup(true);

    const [showAddEmail, setShowAddEmail] = useState(false);
    const [emailFormModified, setEmailFormModified] = useState(false);
    const handleAddEmailClose = () => {
        setShowAddEmail(false);
        setEmailFormModified(false);
    };
    const handleAddEmailShow = () => setShowAddEmail(true);

    const [categoryDetails, setCategoryDetails] = useState({ parentId: null, name: '', type: '', children: [] });
    const [groupDetails, setGroupDetails] = useState({ parentId: null, name: '', type: '', weightage: '' });

    const [selectedStakeholder, setSelectedStakeholder] = useState({ parentId: -1, id: -1 });
    const [selectedForMapping, setSelectedForMapping] = useState([]);

    const [showConfirmation, setShowConfirmation] = useState(false);
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);
    const [messageConfirmation, setMessageConfirmation] = useState('');
    const [selectedForDelete, setSelectedForDelete] = useState({});
    const [updateType, setUpdateType] = useState('');
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(false);
    const [changesDone, setChangesDone] = useState(false);
    const [stakeHoldersMain, setStakeHoldersMain] = useState([]);
    const [filters, setFilters] = useState({
        searchTerm: "",
        selectedType: t("ALL.label"),
    });
    const [stakeholderModalTitle, setStakeholderModalTitle] = useState({ category: '', subCategory: '', type: '' });
    const [showSaveAndProceedConfirmation, setShowSaveAndProceedConfirmation] = useState({ saveSelectedStakeholders: false, proceedToMatIssues: false });
    const [selectedParent, setSelectedParent] = useState(null);
    const [showPrompt, confirmNavigation, cancelNavigation] = useCallbackPrompt(changesDone);
    const [showAddStakeholder, setShowAddStakeholder] = useState(false);
    const [stakeholderDetailsToAdd, setStakeholderDetailsToAdd] = useState([
        {
            id: '',
            name: '',
            email: '',
            categoryId: '',
            groupId: '',
            groups: [],
        }
    ]);
    const [categories, setCategories] = useState([]);
    const [validatedAddStakeholder, setValidatedAddStakeholder] = useState(false);

    const selectedYear = localStorage.getItem(LS_SELECTED_MAT_ISSUE_YEAR) ?? null
    const year = new Date().getFullYear();

    const [filter, setFilter] = useState({
        year: selectedYear ?? `${year}`,
    });
    const glbRegulationId = localStorage.getItem(LS_REGULATION_SELECTED_KEY);
    const lsDat = JSON.parse(localStorage.getItem(LS_AUTHORITY_KEY));
    const companyId = lsDat.profile.company.id;
    // Create yearOptions after all hooks are declared
    const yearOptions = [];
    for (let i = currentYear; i >= startYear; i--) {
        yearOptions.push(<option value={i} key={i}>{i}</option>);
    }

    useEffect(() => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            selectedType: t("ALL.label"),
        }));
    }, []);

    useEffect(() => {
        localStorage.setItem(LS_SELECTED_MAT_ISSUE_YEAR, filter.year);
        setFilters((prevFilters) => ({
            ...prevFilters,
            selectedType: t("ALL.label"),
            searchTerm: ""
        }));
        getStakeHolders();
    }, [filter]);

    const getStakeHolders = (type = '') => {
        setLoaderDisplay(true);
        StakehodlerLibraryService.getAllStakeholders(`${filter.year}`, companyId)
            .then(res => {
                setLoaderDisplay(false);
                if (res.status !== 200) return;
                const result = res.data;
                if (result.length == 0) {
                    setStakeholders([]);
                    setStakeHoldersMain([]);
                    setStakeholderDetails({});
                    setStakeholderDetailsMain({});
                    setStakeholderVisibility({});
                } else {
                    result?.sort((a, b) => a.name.localeCompare(b.name));
                    if (result.some(item => item.active === true)) {
                        setSaveButtonEnabled(true);
                    } else {
                        setSaveButtonEnabled(false);
                    }
                    result.forEach(element => {
                        if (element.stakeholderCount === 0) {
                            element['active'] = false;
                        }
                    });
                    setStakeholders(result);
                    setStakeHoldersMain(result);
                }
                const parentIds = Object.keys(stakeholderVisibility);
                if (parentIds?.length == 0) {
                    setStakeholderDetails({});
                    setStakeholderDetailsMain({});
                }
                parentIds?.forEach(parentId => {
                    if (!stakeholderVisibility[parentId]) return;
                    getStakeHolderDetails(+parentId, null, type);
                });
                setChangesDone(false);
            })
            .catch(err => {
                setLoaderDisplay(false);
            });
    };

    const handleSearch = (event) => {
        const searchQuery = event.target.value;
        setFilters((prevFilters) => ({
            ...prevFilters,
            searchTerm: searchQuery,
        }));
        filterStakeholders(searchQuery, filters.selectedType);
    };

    const filterWithType = (event) => {
        const type = event.target.value;
        setFilters((prevFilters) => ({
            ...prevFilters,
            selectedType: type,
        }));
        filterStakeholders(filters.searchTerm, type);
    };

    // Filter stakeholders based on search query and selected type
    const filterStakeholders = (searchQuery, type) => {
        let filtered = stakeHoldersMain;
        let childFiltered = stakeholderDetailsMain;
        if (type != "ALL") {
            filtered = filtered.filter((stakeholder) => stakeholder.type === type);
        }

        // Filter by the search query
        if (searchQuery !== "") {
            const filterData = searchEntities(searchQuery, filtered, childFiltered);

            if (filterData.source == 'main') {
                setStakeholders(filterData.result);
            } else if (filterData.source == 'sub') {
                setStakeholderDetails(filterData.result);
                setStakeholders(filterData.additionalArrayMatches);
            } else {
                setStakeholders([]);
                setStakeholderDetails({});
            }
        } else {
            setStakeholders(filtered);
            setStakeholderDetails(childFiltered);
        };
    };

    const searchEntities = (searchTerm, array, nestedObject) => {
        const containsSearchTerm = (str) =>
            str.toLowerCase().includes(searchTerm.toLowerCase());
        const filteredArray = array.filter((item) => containsSearchTerm(item.name));

        // If matches are found in the main array, return
        if (filteredArray.length > 0) {
            return { source: "main", result: filteredArray };
        }

        const result = {};
        const additionalArrayMatches = [];

        Object.keys(nestedObject).forEach((key) => {
            const obj = nestedObject[key];

            // Filter children based on the search term
            const filteredChildren = obj.children.filter((child) =>
                containsSearchTerm(child.name)
            );

            if (filteredChildren.length > 0) {
                result[key] = { ...obj, children: filteredChildren };

                const matchingArrayObject = array.find((item) => item.id === obj.id);
                if (matchingArrayObject) {
                    additionalArrayMatches.push(matchingArrayObject);
                }
            }
        });

        if (Object.keys(result).length > 0) {
            return {
                source: "sub",
                result: result,
                additionalArrayMatches: additionalArrayMatches,
            };
        }

        return { source: "none", result: [] };
    };



    const getStakeHolderDetails = (id, value, type = '') => {
        setLoaderDisplay(true);
        StakehodlerLibraryService.getStakeholderDet(id)
            .then(res => {
                setLoaderDisplay(false);
                if (res.status !== 200) return;
                const result = res.data;
                result?.children?.sort((a, b) => a.name.localeCompare(b.name));
                if (result.children.length > 0) {
                    result.children.forEach(element => {
                        element?.groups?.sort((a, b) => a.name.localeCompare(b.name));
                    });
                }
                if (value != null) {
                    if (result.children.length > 0) {
                        result.children.forEach(element => {
                            // if (element.groups.length > 0) {
                            element['active'] = value;
                            // }
                        });
                    }
                }
                if (type === 'stakeHolderAdded') {
                    const data = JSON.parse(JSON.stringify(stakeholders));
                    if (result.children.length > 0) {
                        result.children.forEach(element => {
                            if (element.groups.length > 0) {
                                element['active'] = true;

                                const parent = data.find(item => item.id === element.parentId);
                                if (parent) {
                                    parent['active'] = true;
                                }
                            }
                        });
                    }
                    setStakeholders(data);
                    setChangesDone(true);

                    const dataToSend = [];
                    data.forEach(element => {
                        dataToSend.push({
                            id: element.id,
                            active: element.active,
                        });
                    });

                    result.children.forEach(element => {
                        if (element.groups.length > 0) {
                            dataToSend.push({
                                id: element.id,
                                active: true,
                            });
                        }
                    });
                    mapSelStakeHolders(dataToSend, type);
                }
                setStakeholderDetails(prevState => ({
                    ...prevState,
                    [id]: result,
                }));
                setStakeholderDetailsMain(prevState => ({
                    ...prevState,
                    [id]: result,
                }));
            })
            .catch(err => {
                setLoaderDisplay(false);
            });
    };

    const upsertStakeHoldersCategory = (e) => {
        e.preventDefault();
        if (!categoryDetails.name || !categoryDetails.type) {
            setValidated(true);
            return;
        }

        // Include Financial Materiality setting in the payload
        const payloadWithFinancialMateriality = {
            ...categoryDetails,
            financialMateriality: financialMaterialityEnabled
        };

        setLoaderDisplay(true);
        StakehodlerLibraryService.upsertStakeholderCategory(`${filter.year}`, companyId, [payloadWithFinancialMateriality])
            .then(res => {
                setLoaderDisplay(false);
                if (res.status !== 200) return;
                toast.success('Category added successfully', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setShowAddCategory(false);
                setCategoryDetails({ parentId: null, name: '', type: '', weightage: '', children: [] })
                getStakeHolders();
            })
            .catch(err => {
                setLoaderDisplay(false);
            });
    };

    const upsertStakeHoldersGroup = (e) => {
        e.preventDefault();
        if (!groupDetails.name) {
            setValidatedGroup(true);
            return;
        }
        const passData = groupDetails;
        passData['parentId'] = selectedParent.id;
        passData['type'] = selectedParent.type;
        passData['financialMateriality'] = true;
        setLoaderDisplay(true);
        StakehodlerLibraryService.upsertStakeholderCategory(`${filter.year}`, companyId, [passData])
            .then(res => {
                setLoaderDisplay(false);
                if (res.status !== 200) return;
                toast.success('Group added successfully', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setShowAddGroup(false);
                setGroupDetails({ parentId: null, name: '', type: '', weightage: '' });
                setSelectedParent(null);
                getStakeHolders();
            })
            .catch(err => {
                setLoaderDisplay(false);
            });
    };

    const updateStakeHolderCategory = (e) => {
        e.preventDefault();
        if (!categoryDetails.name || !categoryDetails.type) {
            setValidatedGroup(true);
            return;
        }
        const passData = {
            id: categoryDetails.id,
            name: categoryDetails.name,
            type: categoryDetails.type,
            parentId: categoryDetails.parentId,
            weightage: categoryDetails.weightage,
            financialMateriality: financialMaterialityEnabled
        }
        setLoaderDisplay(true);
        StakehodlerLibraryService.updateStakeholderGroup(categoryDetails.id, passData)
            .then(res => {
                setLoaderDisplay(false);
                if (res.status !== 200) return;
                toast.success('Category updated successfully', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setShowAddCategory(false);
                setCategoryDetails({ parentId: null, name: '', type: '', weightage: '' });
                setSelectedParent(null);
                setUpdateType('');
                getStakeHolders();
            })
            .catch(err => {
                setLoaderDisplay(false);
            });
    }

    const updateStakeHolderGroup = (e) => {
        e.preventDefault();
        if (!groupDetails.name) {
            setValidatedGroup(true);
            return;
        }
        const passData = {
            id: groupDetails.id,
            name: groupDetails.name,
            type: selectedParent.type,
            parentId: groupDetails.parentId,
            weightage: groupDetails.weightage,
            financialMateriality: true
        }
        setLoaderDisplay(true);
        StakehodlerLibraryService.updateStakeholderGroup(groupDetails.id, passData)
            .then(res => {
                setLoaderDisplay(false);
                if (res.status !== 200) return;
                toast.success('Group updated successfully', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setShowAddGroup(false);
                setGroupDetails({ parentId: null, name: '', type: '', weightage: '' });
                setSelectedParent(null);
                setUpdateType('');
                getStakeHolders();
            })
            .catch(err => {
                setLoaderDisplay(false);
            });
    }

    const mapSelStakeHolders = (passData, type = '') => {
        if (passData.length > 0) {
            setLoaderDisplay(true);
            StakehodlerLibraryService.mapStakeholders(`${filter.year}`, companyId, passData)
                .then(res => {
                    setLoaderDisplay(false);
                    if (res.status !== 200) return;
                    // toast.success('Sucessfully selected stakeholders', {
                    //     position: toast.POSITION.TOP_RIGHT,
                    // });

                    if (type === 'stakeHolderAdded') {
                        setShowSaveAndProceedConfirmation({
                            saveSelectedStakeholders: false,
                            proceedToMatIssues: true,
                        });
                    }
                    setSelectedForMapping([]);
                    getStakeHolders();
                })
                .catch(err => {
                    setLoaderDisplay(false);
                });
        } else {
            toast.warning('Please choose category/group for mapping', {
                position: toast.POSITION.TOP_RIGHT,
            });
        }
    };

    const onSelectClicked = () => {
        for (const [key, value] of Object.entries(stakeholderDetails)) {
            if (value.children?.some(child => child.active && child.groups.length === 0)) {
                toast.warning('Please add at least one stakeholder for each of the selected groups', {
                    position: toast.POSITION.TOP_RIGHT,
                });

                return;
            }
        }

        setShowSaveAndProceedConfirmation({
            ...showSaveAndProceedConfirmation,
            saveSelectedStakeholders: true,
        });
    }

    const processMapping = (val) => {
        setShowSaveAndProceedConfirmation({ saveSelectedStakeholders: false, proceedToMatIssues: false });
        if (val) {
            const dataToSend = [];
            stakeholders.forEach(element => {
                dataToSend.push({
                    id: element.id,
                    active: element.active,
                });
            });

            for (const [key, value] of Object.entries(stakeholderDetails)) {
                if (value.groupCount > 0) {
                    value.children.forEach(element => {
                        dataToSend.push({
                            id: element.id,
                            active: element.active,
                        });
                    })
                }
            }
            mapSelStakeHolders(dataToSend);
        }
    }

    const navigateToMatIssues = (val) => {
        setShowSaveAndProceedConfirmation({ saveSelectedStakeholders: false, proceedToMatIssues: false });
        if (val) {
            navigate(`/company_admin/dmat/issues`);
        }
    }

    // Validate form fields
    const validateFields = () => {
        for (const field of formFields) {
            if (!field.name.trim() || !field.email.trim()) {
                // alert("Name and Email are required for all entries.");
                toast.warning('Name and Email are required for all entries', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                return false;
            }
            // Email validation using ReDoS-safe utility function
            // Validations.isValidEmail() includes comprehensive ReDoS protection:
            // - Length check (254 chars max per RFC 5321)
            // - Multi-layered validation with string splitting
            // - Safe regex patterns that prevent catastrophic backtracking
            if (!Validations.isValidEmail(field.email)) {
                toast.warning(`Invalid email format: ${field.email}`, {
                    position: toast.POSITION.TOP_RIGHT,
                });
                return false;
            }
        }
        return true;
    }

    const refreshEmailFormFields = () => {
        const { parentId, id } = selectedStakeholder;
        if (!parentId || !id) return;

        StakehodlerLibraryService.getStakeholderDet(parentId)
            .then(res => {
                if (res.status !== 200) return;
                const result = res.data;
                const child = result.children?.find(c => c.id === id);
                if (child) {
                    setFormFields(child.groups?.length > 0 ? child.groups : [{ name: "", email: "" }]);
                }
                setStakeholderDetails(prevState => ({
                    ...prevState,
                    [parentId]: result,
                }));
                setStakeholderDetailsMain(prevState => ({
                    ...prevState,
                    [parentId]: result,
                }));
            })
            .catch(() => { });
    };

    const upsertStakeHoldersEmails = (action = 'done') => {
        if (!validateFields()) {
            return;
        }

        const payload = formFields.map((field) => ({
            ...field,
            type: stakeholderModalTitle.type,
        }));

        setLoaderDisplay(true);
        StakehodlerLibraryService.upsertStakeholderEmails(selectedStakeholder.id, companyId, payload)
            .then(res => {
                setLoaderDisplay(false);
                if (res.status !== 200) return;

                if (action === 'save') {
                    toast.success(t("Stakeholders.emailModal.saveSuccess.label"), {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    setEmailFormModified(false);
                    refreshEmailFormFields();
                    getStakeHolders();
                    return;
                }

                setShowAddEmail(false);
                setFormFields([{ name: "", email: "" }]);
                setEmailFormModified(false);
                setSelectedStakeholder({});
                getStakeHolders('stakeHolderAdded');
            })
            .catch(err => {
                setLoaderDisplay(false);
            });
    };

    const handleEmailModalDone = () => {
        if (emailFormModified) {
            upsertStakeHoldersEmails('done');
            return;
        }

        setShowAddEmail(false);
        setFormFields([{ name: "", email: "" }]);
        setEmailFormModified(false);
        setSelectedStakeholder({});
        getStakeHolders('stakeHolderAdded');
    };

    const toggleStakeholderVisibility = (id) => {
        const t = JSON.parse(JSON.stringify(stakeholderVisibility));
        if (t[id] === true) {
            t[id] = false;
        } else {
            t[id] = true;
            getStakeHolderDetails(id, null);
        }
        setStakeholderVisibility(t);
    };

    const openWhenChecked = (id, value) => {
        const t = JSON.parse(JSON.stringify(stakeholderVisibility));
        if (t[id] == true) {
            const data = stakeholderDetails[id];
            if (data.children.length > 0) {
                data.children.forEach(element => {
                    // if (element.groups.length > 0) {
                    element['active'] = value;
                    // }
                });
            }
            const master = stakeholderDetails;
            master[id] = data;
            setStakeholderDetails(master);
            setStakeholderDetailsMain(master);
        } else {
            t[id] = true;
            getStakeHolderDetails(id, value);
            setStakeholderVisibility(t);
        }
    };

    const handleInputChange = (index, event) => {
        const { name, value } = event.target;
        const newFormFields = [...formFields];
        newFormFields[index][name] = value;
        setFormFields(newFormFields);
        setEmailFormModified(true);
    };

    const handleAddFields = () => {
        setFormFields([...formFields, { name: "", email: "" }]);
        setEmailFormModified(true);
    };

    const handleDelete = (id, index) => {
        if (id > 0) {
            setLoaderDisplay(true);
            StakehodlerLibraryService.deleteStakeholderGroupEmail(id).then(res => {
                setLoaderDisplay(false);
                if (res.status !== 204) return;

                toast.success('Stakeholder deleted', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                const newFormFields = formFields.filter((_, i) => i !== index);
                setFormFields(newFormFields);
                getStakeHolderDetails(selectedStakeholder.parentId);
            })
                .catch(err => {
                    setLoaderDisplay(false);
                });
        } else {
            const newFormFields = formFields.filter((_, i) => i !== index);
            setFormFields(newFormFields);
            setEmailFormModified(true);
        }
    };

    const setupEditEmails = (parentId, stkId, groups, stake, child) => {
        // if (changesDone) {
        //     toast.warning('Save selected items before adding stakeholders', {
        //         position: toast.POSITION.TOP_RIGHT,
        //         autoClose: 2000
        //     });
        // } else {
        if (groups.length == 0) {
            setFormFields([{ name: "", email: "" }]);
        } else {
            setFormFields(groups);
        }
        setSelectedStakeholder({ parentId: parentId, id: stkId });
        setEmailFormModified(false);
        handleAddEmailShow();
        setStakeholderModalTitle({ category: stake.name, subCategory: child.name, type: child.type });
        // }

    }

    const onSingleSelection = (id) => {
        const ids = [...selectedForMapping];
        const index = selectedForMapping.indexOf(id);
        if (index >= 0) {
            ids.splice(index, 1);
        } else {
            ids.push(id);
        }
        setSelectedForMapping(ids);
    };

    const setCheckBoxStatus = (type, id, cId) => {
        setChangesDone(true);
        if (type == 'parent') {
            const data = JSON.parse(JSON.stringify(stakeholders));
            let currentValue = null;
            data.forEach(element => {
                if (element.id == id) {
                    element['active'] = !element['active'];
                    currentValue = element['active'];
                    return;
                }
            })
            if (data.some(item => item.active === true)) {
                setSaveButtonEnabled(true);
            } else {
                setSaveButtonEnabled(false);
            }
            setStakeholders(data);
            openWhenChecked(id, currentValue);
        } else {
            const data = stakeholderDetails[id];
            if (data.children.length > 0) {
                let currentValue = null;
                data.children.forEach(element => {
                    if (element.id == cId) {
                        element['active'] = !element['active'];
                        currentValue = element['active'];
                        return;
                    }
                });
                if (data.children.some(item => item.active === true)) {
                    setSaveButtonEnabled(true);
                } else {
                    setSaveButtonEnabled(false);
                }
                if (currentValue) {
                    const data = JSON.parse(JSON.stringify(stakeholders));
                    data.forEach(element => {
                        if (element.id == id) {
                            element['active'] = true;
                            return;
                        }
                    })
                    setStakeholders(data);
                } else {
                    if (!data.children.some(item => item.active === true)) {
                        const parent = JSON.parse(JSON.stringify(stakeholders));
                        parent.forEach(element => {
                            if (element.id == id) {
                                element['active'] = false;
                                return;
                            }
                        })
                        setStakeholders(parent);
                    }
                }
            }
            setStakeholderDetails(prevState => ({
                ...prevState,
                [id]: data,
            }));
            setStakeholderDetailsMain(prevState => ({
                ...prevState,
                [id]: data,
            }));
            processMapping(true);
        }
    }

    const deleteStakeHolderData = (id) => {
        setLoaderDisplay(true);
        StakehodlerLibraryService.deleteStakeData(id)
            .then(res => {
                setLoaderDisplay(false);
                if (res.status !== 200) return;
                toast.success('Data deleted successfully', {
                    position: toast.POSITION.TOP_RIGHT,
                });
                setSelectedForDelete({});
                delete stakeholderVisibility[id];
                getStakeHolders();
            })
            .catch(err => {
                setLoaderDisplay(false);
            });
    };

    const showDeleteConfirm = (data) => {
        if (data.stakeholderCount == 0) {
            setSelectedForDelete(data);
            setShowDeleteConfirmation(true);
        } else {
            toast.warning('Delete all groups before deleting category', {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 2000
            });
        }
    }

    const confirmDelete = (val) => {
        setShowDeleteConfirmation(false);
        if (val) {
            deleteStakeHolderData(selectedForDelete.id);
        }
    };

    const confirmCopy = (val) => {
        setShowConfirmation(false);
        if (val) {
            getAllParentChildStakeholders();
        }
    };

    const getAllParentChildStakeholders = () => {
        setLoaderDisplay(true);
        StakehodlerLibraryService.getAllParentChildStakeholders().then(res => {
            setLoaderDisplay(false);
            if (res.status !== 200) return;
            const result = res.data.data;
            if (result.length > 0) {
                result.forEach(element => {
                    element['masterRef'] = element['id'];
                    delete element['id'];
                    if (element['hasChildren']) {
                        element['children'].forEach(el => {
                            el['masterRef'] = el['id'];
                            // el['type'] = 'INTERNAL';
                            delete el['id'];
                        });
                    }
                });
                upsertMasterData(result);
            }
        }).catch(err => {
            setLoaderDisplay(false);
        });
    };

    const upsertMasterData = (data) => {
        // Add financialMateriality: true only to parent objects
        const dataWithFinancialMateriality = data.map(item => ({
            ...item,
            financialMateriality: true
        }));

        setLoaderDisplay(true);
        StakehodlerLibraryService.upsertStakeholderCategory(`${filter.year}`, companyId, dataWithFinancialMateriality)
            .then(res => {
                setLoaderDisplay(false);
                if (res.status !== 200) return;
                toast.success(t("MasterDataPatchedMsg.label"), {
                    position: toast.POSITION.TOP_RIGHT,
                });
                getStakeHolders();
            })
            .catch(err => {
                setLoaderDisplay(false);
            });
    };

    const editGroup = (parent, data) => {
        setUpdateType('EDIT_GROUP');
        setGroupDetails(data);
        handleAddGroupShow();
        setSelectedParent(parent);
    }

    const editCategory = (data) => {
        setUpdateType('EDIT_CATEGORY');
        setCategoryDetails(data);
        // Set Financial Materiality state based on the category data, default to true
        setFinancialMaterialityEnabled(data.financialMateriality !== undefined ? data.financialMateriality : true);
        // Directly show the modal for editing (don't call handleAddCategoryShow to avoid resetting the toggle)
        setShowAddCategory(true);
    }

    const renderSHBubbles = (parentId, stkId, groups, stake, child) => {
        let permCount = 0;
        const elements = [];

        groups?.map((group, gIndex) => {
            if (permCount >= 3) {
            } else {
                elements.push(
                    <OverlayTrigger
                        key={`assmtSharedGroup-${gIndex}`}
                        placement="top" overlay={Utils.renderTooltip(
                            <span>
                                {t('Name.label')}: {group.name} <br />
                                {t('Email.label')}: {group.email}
                            </span>
                        )}>
                        <li className='cursor' key={`assmtSharedGroup-${gIndex}`} onClick={() => setupEditEmails(parentId, stkId, groups, stake, child)}>
                            {Utils.getTextBasedProfilePic(group.name)}
                        </li>
                    </OverlayTrigger>
                );
            }
            permCount++;
        });

        if (permCount > 3) {
            elements.push(<li key='shareCountKey' className="Share_count cursor" onClick={() => setupEditEmails(parentId, stkId, groups, stake, child)}>+{permCount - 3}</li>);
        }
        return elements;
    };

    const blankCardToRender = () => {
        return (
            <div className="Assessment_blankcard">
                <div>
                    <div className="assessment_pic">
                        <img src={assessment_pic} />
                    </div>
                    <h4 className="mb-4">{t('StakeholderBlankHeader.label')}</h4>
                    <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t('ImportFromLibraryTooltip.label'))}>
                        <Button variant="primary" className="px-3" onClick={() => setShowConfirmation(true)}>
                            <BiImport className="mr-2" /> {t("ImportFromLibrary.label")}
                        </Button>
                    </OverlayTrigger>
                    <Button variant="primary" className="px-3 mx-2" onClick={handleAddCategoryShow}>
                        <BiPlus className="mr-2" /> {t("Category.label")}
                    </Button>
                </div>
            </div>
        );
    };

    const noDataRender = () => {
        return (
            <tr>
                <td colSpan="7" className="text-center">
                    <h6>{t("Nodatafound.label")}</h6>
                </td>
            </tr>
        )
    }


    const renderStakeholders = () => {
        return (
            <div className='Stakeholders_table'>
                <Table>
                    <thead>
                        <tr>
                            <th>
                                {/* <Form.Check // prettier-ignore
                                    type="checkbox"
                                    id="check1"
                                /> */}
                            </th>
                            <th>{t("CategoryGroup.label")}</th>
                            <th>{t("Stakeholders.label")}</th>
                            <th className='text-center'>{t("Type.label")}</th>
                            <th className='text-center'>
                                {t("Weightage.label")}
                                <OverlayTrigger
                                    placement="bottom"
                                    overlay={Utils.renderTooltip(t('WeightageHeaderInfo.label'))}>
                                    <span className='font-18 ms-2'><BiInfoCircle /></span>
                                </OverlayTrigger>
                            </th>
                            <th className='text-center'>{t("Action.label")}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(stakeholders.length == 0 && stakeHoldersMain.length > 0) ? noDataRender() : renderStakeholderRow()}
                    </tbody>
                </Table>
            </div>
        )
    }

    const renderStakeholderRow = () => {
        return (
            <>
                {
                    stakeholders?.map((stake, index) => {
                        return (
                            <>
                                <tr className='MainHolder' id={`MainHolder-${index}`} key={`MainHolder-${index}`}>
                                    <td>
                                        <Form.Check // prettier-ignore
                                            className='d-none'
                                            type="checkbox"
                                            id={`maincheck-${index}`}
                                            name="group1"
                                            checked={stake.active ? "checked" : ""}
                                            onChange={() => {
                                                setCheckBoxStatus('parent', stake.id, null)
                                            }}
                                        // disabled={stake.stakeholderCount == 0}
                                        />
                                    </td>
                                    <td>
                                        <div className='MainHolder_dt cursor' onClick={() => toggleStakeholderVisibility(stake.id)}>
                                            {
                                                stake.groupCount > 0 &&
                                                <span>
                                                    {!stakeholderVisibility[stake.id] && <BiChevronDown />}
                                                    {stakeholderVisibility[stake.id] === true && <BiChevronUp />}
                                                </span>
                                            }
                                            {stake?.name}
                                        </div>
                                    </td>
                                    <td>{stake?.stakeholderCount}</td>
                                    <td className='text-center'>{stake?.type === 'INTERNAL' ? 'Internal' : 'External'}</td>
                                    <td className='text-center'>{stake?.weightage ? stake?.weightage + '%' : ''}</td>
                                    <td className='text-center'>

                                        <Dropdown>
                                            <Dropdown.Toggle variant="blank_outline">
                                                <BiDotsHorizontalRounded />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => { handleAddGroupShow(); setSelectedParent(stake) }}>
                                                    <BiPlusCircle className='me-2' /> {t("AddGroup.label")}
                                                </Dropdown.Item>
                                                <Dropdown.Item onClick={() => editCategory(stake)}>  <BiPencil className='me-2' /> {t("EditCategory.label")}</Dropdown.Item>
                                                <Dropdown.Item onClick={() => showDeleteConfirm(stake)}>   <BiTrash className='me-2' /> {t("DeleteCategorySH.label")}</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>

                                        {/* <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("EditCategory.label"))}>
                                            <button className='btn btn-blank_outline' >
                                                <BiSolidPencil />
                                            </button>
                                        </OverlayTrigger>
                                        <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("DeleteCategorySH.label"))}>
                                            <button className='btn btn-blank_outline' onClick={() => showDeleteConfirm(stake)}>
                                                <BiSolidTrash />
                                            </button>
                                        </OverlayTrigger> */}

                                    </td>
                                </tr>
                                {stakeholderVisibility[stake.id] === true && renderStakeholderSubRow(stake, index, stakeholderDetails[stake.id])}
                            </>
                        );
                    })
                }
            </>
        )
    }

    const renderStakeholderSubRow = (stake, index, stakeDetails) => {
        return (
            <>
                {
                    stakeDetails?.children?.map((child, cIndex) => {
                        return (
                            <>
                                <tr className='SubHolder' id={`SubHolder-${index}-${cIndex}`} key={`SubHolder-${index}-${cIndex}`}>
                                    <td>

                                    </td>
                                    <td>
                                        <div className='SubHolder_dt d-flex align-items-center gap-2'>
                                            <Form.Check // prettier-ignore
                                                type="checkbox"
                                                id={`subcheck-${index}-${cIndex}`}
                                                name="group2"
                                                checked={child.active ? "checked" : ""}
                                                onChange={() => {
                                                    setCheckBoxStatus('child', stake.id, child.id)
                                                }}
                                            // disabled={child.groups.length == 0}
                                            />
                                            {child?.name}
                                        </div>
                                    </td>
                                    <td>
                                        <ul>
                                            {child.groups.length > 0 ? renderSHBubbles(stakeDetails.id, child.id, child.groups, stake, child) : 0}
                                            {/* <li>
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={Utils.renderTooltip(
                                                        t("AddStakeholderTooltip.label")
                                                    )}>
                                                    <span className='add_stakeholder' onClick={() => setupEditEmails(stakeDetails.id, child.id, child.groups, stake, child)}>
                                                        <BiPlusCircle />
                                                    </span>
                                                </OverlayTrigger>
                                            </li> */}
                                        </ul>
                                    </td>
                                    <td className='text-center'>{child?.type === 'INTERNAL' ? 'Internal' : 'External'}</td>
                                    <td className='text-center'>{child?.weightage ?? 0}%</td>
                                    <td className='text-center'>

                                        <Dropdown>
                                            <Dropdown.Toggle variant="blank_outline">
                                                <BiDotsHorizontalRounded />
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={() => setupEditEmails(stakeDetails.id, child.id, child.groups, stake, child)}>
                                                    <BiPlusCircle className='me-2' /> {t("AddStakeholderTooltip.label")}</Dropdown.Item>
                                                <Dropdown.Item onClick={() => editGroup(stake, child)}>  <BiPencil className='me-2' /> {t("EditGroup.label")}</Dropdown.Item>
                                                <Dropdown.Item onClick={() => showDeleteConfirm(child)}>   <BiTrash className='me-2' /> {t("DeleteGroup.label")}</Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>

                                        {/* <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("AddStakeholderTooltip.label"))}>
                                            <button className='btn btn-blank_outline' onClick={() => setupEditEmails(stakeDetails.id, child.id, child.groups, stake, child)}>
                                                <BiPlusCircle />
                                            </button>
                                        </OverlayTrigger>
                                        <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("EditGroup.label"))}>
                                            <button className='btn btn-blank_outline' onClick={() => editGroup(stake, child)}>
                                                <BiPencil />
                                            </button>
                                        </OverlayTrigger>
                                        <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("DeleteGroup.label"))}>
                                            <button className='btn btn-blank_outline' onClick={() => showDeleteConfirm(child)}>
                                                <BiTrash />
                                            </button>
                                        </OverlayTrigger> */}
                                    </td>
                                </tr>
                            </>
                        );
                    })
                }
            </>
        )
    }

    const getAllCategories = () => {
        setLoaderDisplay(true);
        StakehodlerLibraryService.getAllStakeholders(`${filter.year}`, companyId)
            .then(res => {
                setLoaderDisplay(false);
                if (res.status !== 200) return;

                setCategories(res.data?.sort((a, b) => a.name.localeCompare(b.name)));
            })
            .catch(err => {
                setLoaderDisplay(false);
            });
    }

    const getCategoryWiseGroups = async (categoryId) => {
        setLoaderDisplay(true);
        try {
            const res = await StakehodlerLibraryService.getStakeholderDet(categoryId);
            setLoaderDisplay(false);

            if (res.status !== 200) return [];

            return res.data?.children?.sort((a, b) => a.name.localeCompare(b.name)) || [];
        } catch (err) {
            setLoaderDisplay(false);
            console.error("Error fetching groups:", err);
            return [];
        }
    };

    const preparePayload = () => {
        const payload = stakeholderDetailsToAdd.map(({ id, name, email, categoryId, groupId }) => ({
            id,
            name,
            email,
            categoryId,
            groupId,
        }));
        return payload;
    };


    const upsertStakeholders = (e) => {
        e.preventDefault();
        if (stakeholderDetailsToAdd.some(stakeholder =>
            !stakeholder.name ||
            !stakeholder.email ||
            !stakeholder.categoryId ||
            !stakeholder.groupId)) {
            setValidatedAddStakeholder(true);
            return;
        }

        const payload = preparePayload();

        setLoaderDisplay(true);
        StakehodlerLibraryService.upsertMultipleStakeholders(companyId, payload)
            .then(res => {
                setLoaderDisplay(false);
                if (res.status !== 200) return;

                toast.success('Data added successfully', {
                    position: toast.POSITION.TOP_RIGHT,
                });

                getStakeHolders();
                handleAddStakeholderClose();
            })
            .catch(err => {
                setLoaderDisplay(false);
            });
    }

    const addOrEditStakeholder = async (item, type) => {
        setShowAddStakeholder(true);
        getAllCategories();
    }

    const handleAddStakeholderClose = () => {
        setShowAddStakeholder(false);
        setStakeholderDetailsToAdd([
            {
                id: '',
                name: '',
                email: '',
                categoryId: '',
                groupId: '',
                groups: []
            }
        ]);
        setCategories([]);
        setValidatedAddStakeholder(false);
    };

    const handleAddStakeholderChange = async (index, event) => {
        const { name, value } = event.target;
        const updatedStakeholders = [...stakeholderDetailsToAdd];

        updatedStakeholders[index][name] = value;

        if (name === 'categoryId') {
            try {
                const categoryGroups = await getCategoryWiseGroups(value);
                updatedStakeholders[index].groups = categoryGroups;
                updatedStakeholders[index].groupId = '';
            } catch (error) {
                console.error("Error fetching groups:", error);
            }
        }
        setStakeholderDetailsToAdd(updatedStakeholders);
    };

    const handleAddNewStakeholderFields = () => {
        setStakeholderDetailsToAdd([
            ...stakeholderDetailsToAdd,
            {
                id: '',
                name: '',
                email: '',
                categoryId: '',
                groupId: '',
                groups: [],
            }
        ]);
        setValidatedAddStakeholder(false);
    };

    const handleDeleteStakeholderField = (index) => {
        const newFormFields = stakeholderDetailsToAdd.filter((_, i) => i !== index);
        setStakeholderDetailsToAdd(newFormFields);
    }

    // Financial Materiality toggle handler
    const handleFinancialMaterialityToggle = (enabled) => {
        setFinancialMaterialityEnabled(enabled);
    }

    const renderAddStakeholderModal = () => {
        return (
            <Modal show={showAddStakeholder} onHide={() => { handleAddStakeholderClose(); }}
                size='xl'
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title as="h5">{t("Addstakeholder.label")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form noValidate validated={validatedAddStakeholder}>

                        <table className='table AddStakeholder_01A'>
                            <thead>
                                <tr>
                                    <th>{t("Name.label")} <span className="text-danger p-0">*</span></th>
                                    <th> {t("Email.label")} <span className="text-danger p-0">*</span></th>
                                    <th>{t("Category.label")} <span className="text-danger">*</span></th>
                                    <th>{t("Group.label")} <span className="text-danger">*</span></th>
                                    <th></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                {stakeholderDetailsToAdd.map((stakeholder, index) => (
                                    <tr key={index}>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                // placeholder="Name"
                                                value={stakeholder.name}
                                                name="name"
                                                onChange={(e) => handleAddStakeholderChange(index, e)}
                                                required
                                                maxLength={250}
                                            />
                                        </td>
                                        <td>
                                            <input
                                                type="text"
                                                className="form-control"
                                                // placeholder="Email"
                                                value={stakeholder.email}
                                                name="email"
                                                onChange={(e) => handleAddStakeholderChange(index, e)}
                                                required
                                                maxLength={250}
                                            />
                                        </td>
                                        <td className='SH_Category-td'>
                                            <select
                                                className='form-select'
                                                name="categoryId"
                                                required
                                                value={stakeholder.categoryId}
                                                onChange={(e) => handleAddStakeholderChange(index, e)}
                                            >
                                                <option value='' key='' disabled>{t('Select.label')}</option>
                                                {categories?.map((e) => (
                                                    <option value={e.id} key={e.id}>{e.name}</option>
                                                ))}
                                            </select>
                                        </td>
                                        <td className='SH_Group-td'>
                                            <select
                                                className='form-select'
                                                name="groupId"
                                                required
                                                value={stakeholder.groupId}
                                                onChange={(e) => handleAddStakeholderChange(index, e)}
                                                disabled={!stakeholder.categoryId || !Array.isArray(stakeholder.groups)}
                                            >
                                                <option value='' key='' disabled>{t('Select.label')}</option>
                                                {stakeholder.groups?.map((e) => (
                                                    <option value={e.id} key={e.id}>{e.name}</option>
                                                ))}
                                            </select>
                                        </td>
                                        <td>
                                            {
                                                stakeholderDetailsToAdd.length > 1 &&
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={Utils.renderTooltip(
                                                        'Delete'
                                                    )}>
                                                    <Button variant='GroupStake' onClick={() => handleDeleteStakeholderField(index)}>
                                                        <BiTrash />
                                                    </Button>
                                                </OverlayTrigger>
                                            }
                                        </td>
                                        <td>
                                            {
                                                stakeholderDetailsToAdd.length - 1 === index &&
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={Utils.renderTooltip(
                                                        'Add new'
                                                    )}>
                                                    <Button variant='GroupStake' className='btn-outline-primary  border-0' onClick={handleAddNewStakeholderFields}>
                                                        <BiPlusCircle />
                                                    </Button>
                                                </OverlayTrigger>
                                            }
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        <div className='p-2 pt-3 text-center'>
                            <Button variant="secondary" className='px-4 me-2' onClick={handleAddStakeholderClose}>
                                {t("Close.label")}
                            </Button>
                            {
                                <Button variant="primary" className='px-4' onClick={(e) => upsertStakeholders(e)}>
                                    {t("Save.label")}
                                </Button>
                            }
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>
        );
    };

    return (
        <div className='StakeholdersBox 1'>
            <div className="List_header pb-0">
                <Breadcrumb className='h5'>
                    <Breadcrumb.Item onClick={() => navigate(`/company_admin/dmat/stats`)}>{t("Materiality.label")}</Breadcrumb.Item>
                    <Breadcrumb.Item active>{t("StakeHolders.label")}</Breadcrumb.Item>
                </Breadcrumb>
                <div className='d-flex justify-content-end align-items-center header-actions'>
                    <div className='searchListBox'>
                        <span><BiSearch /></span>
                        <input type='text' className='form-control form-control-sm' placeholder={t("Search.label")}
                            onChange={handleSearch} value={filters.searchTerm} />
                    </div>
                    <select className="form-select  w-auto form-select-sm" value={filters.selectedType} onChange={filterWithType}>
                        <option value={t("ALL.label")}>{t("All.label")}</option>
                        <option value={t("Internal.label").toUpperCase()}>{t("Internal.label")}</option>
                        <option value={t("External.label").toUpperCase()}>{t("External.label")}</option>
                    </select>
                    <div className="StakeholdersCheckCard">
                        <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t('GroupViewTooltip.label'))}>
                            <div className="toggle-switch">
                                <Form.Check
                                    inline
                                    className='form-control-sm'
                                    label={<BiSolidUserPlus />}
                                    type="radio"
                                    id="viewMode1"
                                    value={'GRID'}
                                    checked
                                />
                            </div>
                        </OverlayTrigger>
                        <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t('ListViewTooltip.label'))}>
                            <div className="toggle-switch">
                                <Form.Check
                                    inline
                                    className='form-control-sm'
                                    label={<BiCopy />}
                                    type="radio"
                                    id="viewMode2"
                                    value={'LIST'}
                                    onClick={() => navigate(`/company_admin/dmat/stakeholders/list`)}
                                />
                            </div>
                        </OverlayTrigger>
                    </div>
                    {/* <button className="btn btn-headbtn" >
                        <BsFilter />
                    </button> */}

                    <select className="form-select  w-auto form-select-sm" value={filter.year}
                        onChange={(e) => {
                            setFilter({ ...filter, year: e.target.value });
                            setEvent({
                                event: EventType.DOUBLE_MAT_YEAR_CHANGED,
                                data: { year: e.target.value },
                            });
                        }}>
                        {yearOptions}
                    </select>

                    <Button variant='primary' className='white-space btn-sm' hidden={!hasDoubleMaterialityUpdatePermission()} onClick={() => addOrEditStakeholder(null)}><BiPlus /> {t("New.label")}</Button>

                    <OverlayTrigger placement="top" overlay={Utils.renderTooltip(t("NavigateBackAndNext.MatIssues"))}>
                        <Button variant='secondary' className='next-btn btn-sm scorecard-btn' onClick={() => navigate(`/company_admin/dmat/issues`)}>
                            <span>{t("Next.label")}</span> <BsChevronRight />
                        </Button>
                    </OverlayTrigger>
                </div>
            </div>
            {
                stakeHoldersMain.length > 0 &&
                <div className='font-14'>
                    {t("SelectStakeholdersMaterialityAssessment.label")}
                </div>
            }
            {stakeHoldersMain.length === 0 && blankCardToRender()}
            {stakeHoldersMain.length > 0 && renderStakeholders()}
            {
                stakeHoldersMain.length > 0 &&
                <>
                    <div className='py-2'>
                        <button className='btn btn-outline-primary border-0' onClick={handleAddCategoryShow}><BiPlus /> {t('Category.label')}</button>
                    </div>
                    <div className='py-2 text-center'>
                        {/* <Button variant='secondary' className='px-4 me-2'>{t('Close.label')}</Button> */}
                        {/* <Button variant='primary' className='px-4'
                            onClick={() => onSelectClicked()}
                            disabled={!saveButtonEnabled}>{t('Select.label')}
                        </Button> */}
                    </div>
                </>
            }

            <Modal show={showAddEmail} onHide={handleAddEmailClose}
                size='lg'
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title as="h5">
                        <Breadcrumb className='h6'>
                            <Breadcrumb.Item href="#">{stakeholderModalTitle.category}</Breadcrumb.Item>
                            <Breadcrumb.Item active>{stakeholderModalTitle.subCategory}</Breadcrumb.Item>
                        </Breadcrumb>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <>
                        <div className='row m-0 align-items-end'>
                            <div className='col-md-5 px-2'>
                                <label className='mb-1 fw-600'>{t("Name.label")} <span className="text-danger">*</span></label>
                            </div>
                            <div className='col-md-5 px-2'>
                                <label className='mb-1 fw-600'>{t("Email.label")} <span className="text-danger">*</span></label>
                            </div>
                        </div>

                        {formFields.map((field, index) => (

                            <div className='row m-0 align-items-end'>

                                <div className='col-md-5 px-2 py-1'>
                                    <input
                                        type="text"
                                        name="name"
                                        // placeholder="Name"
                                        value={field.name}
                                        onChange={(event) => handleInputChange(index, event)}
                                        className="form-control"
                                        required
                                    />
                                </div>
                                <div className='col-md-5 px-2 py-1'>
                                    <input
                                        type="email"
                                        name="email"
                                        // placeholder="Email"
                                        value={field.email}
                                        onChange={(event) => handleInputChange(index, event)}
                                        className="form-control"
                                        required
                                    />
                                </div>
                                <div className='col-md-2 px-2  py-1'>
                                    <ul className='stakeCat_add'>
                                        {
                                            (formFields.length > 1) && (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={Utils.renderTooltip(
                                                        t("Delete.label")
                                                    )}>
                                                    <li>
                                                        <span className='cursor' onClick={() => handleDelete(field.id, index)}>
                                                            <BiTrash />
                                                        </span>
                                                    </li>
                                                </OverlayTrigger>
                                            )}
                                        {
                                            (index === formFields.length - 1) && (
                                                <OverlayTrigger
                                                    placement="top"
                                                    overlay={Utils.renderTooltip(
                                                        t("AddNew.label")
                                                    )}>
                                                    <li>
                                                        <Button variant='GroupStake' className='btn-outline-primary border-0' onClick={() => handleAddFields()}> <BiPlusCircle /></Button>
                                                    </li>
                                                </OverlayTrigger>
                                            )}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </>

                    <div className='p-2 pt-3 text-center'>
                        <Button variant="secondary" className='px-4 me-2' onClick={handleAddEmailClose}>
                            {t("Close.label")}
                        </Button>
                        {emailFormModified && (
                            <Button
                                variant="outline-primary"
                                className='px-4 me-2'
                                onClick={() => upsertStakeHoldersEmails('save')}
                            >
                                {t("Save.label")}
                            </Button>
                        )}
                        <Button variant="primary" className='px-4' onClick={handleEmailModalDone}>
                            {t("Stakeholders.emailModal.done.label")}
                        </Button>
                    </div>

                </Modal.Body>
            </Modal>

            <Modal show={showAddCategory} onHide={() => { handleAddCategoryClose(); setStakeholderDetails({ parentId: null, name: '', type: '', weightage: '', children: [] }) }}
                size='xl'
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title as="h5">{categoryDetails.id ? t("EditCategory.label") : t("NewCategory.label")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form noValidate validated={validated}>
                        <div className='row m-0 align-items-end'>
                            <div className='col-md-5 p-2'>
                                <label className='mb-1'>{t("CategoryName.label")} <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Category"
                                    value={categoryDetails.name}
                                    onChange={(e) => setCategoryDetails({ ...categoryDetails, name: e.target.value })}
                                    required
                                    maxLength={250}
                                />
                            </div>
                            <div className='col-md-7 p-2'>
                                <label className="mb-1">{t("Type.label")} <span className="text-danger">*</span></label>
                                <div className='d-flex align-items-center'>
                                    <Form.Check
                                        type="radio"
                                        inline
                                        label={t("Internal.label")}
                                        className="DataTypeCheck"
                                        name="typeck"
                                        id={`pageCheckbox-1`}
                                        checked={categoryDetails.type === 'INTERNAL'}
                                        onChange={() => setCategoryDetails({ ...categoryDetails, type: 'INTERNAL' })}
                                        required
                                    />
                                    <Form.Check
                                        type="radio"
                                        inline
                                        label={t("External.label")}
                                        className="DataTypeCheck"
                                        name="typeck"
                                        id={`pageCheckbox-1`}
                                        checked={categoryDetails.type === 'EXTERNAL'}
                                        onChange={() => setCategoryDetails({ ...categoryDetails, type: 'EXTERNAL' })}
                                        required
                                    />
                                    <Form.Check
                                        type="switch"
                                        id="financial-materiality-switch"
                                        checked={financialMaterialityEnabled}
                                        onChange={(e) => handleFinancialMaterialityToggle(e.target.checked)}
                                        label={t("Show.FinancialMateriality.label")}
                                        className="ms-2"
                                    />
                                    <OverlayTrigger
                                        placement="top"
                                        overlay={Utils.renderTooltip(t('FinancialMaterialitytoggle.Tooltip.label'))}>
                                        <span className='font-18 ms-2'><BiInfoCircle /></span>
                                    </OverlayTrigger>

                                </div>
                            </div>
                            {/* <div className='col-md-2 p-2'>
                                <Button variant='GroupStake' className='btn-outline-primary border-0'>  <BiPlusCircle /></Button>
                            </div> */}
                        </div>
                        <div className='p-2 pt-3 text-center'>
                            <Button variant="secondary" className='px-4 me-2' onClick={handleAddCategoryClose}>
                                {t("Close.label")}
                            </Button>
                            {
                                updateType == '' &&
                                <Button variant="primary" className='px-4' onClick={(e) => upsertStakeHoldersCategory(e)}>
                                    {t("Save.label")}
                                </Button>
                            }
                            {
                                updateType == 'EDIT_CATEGORY' &&
                                <Button variant="primary" className='px-4' onClick={(e) => updateStakeHolderCategory(e)}>
                                    {t("Update.label")}
                                </Button>
                            }
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            <Modal show={showAddGroup} onHide={handleAddGroupClose}
                size='lg'
                aria-labelledby="contained-modal-title-vcenter"
                centered
                backdrop="static"
                keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title as="h5">{groupDetails.id ? t('EditGroup.label') : t("AddGroup.label")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form noValidate validated={validatedGroup}>
                        <div className='row m-0 align-items-end'>
                            <div className='col-md-5 p-2'>
                                <label className='mb-1'>{t("GroupName.label")} <span className="text-danger">*</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Group"
                                    value={groupDetails.name}
                                    onChange={(e) => setGroupDetails({ ...groupDetails, name: e.target.value })}
                                    required
                                    maxLength={250}
                                />
                            </div>
                            <div className='col-md-5 p-2 d-none'>
                                <label className="mb-1">{t("Type.label")} <span className="text-danger">*</span></label>
                                <div>
                                    <Form.Check
                                        type="radio"
                                        inline
                                        label={t("Internal.label")}
                                        className="DataTypeCheck"
                                        name="typeck"
                                        id={`pageCheckbox-1`}
                                        checked={groupDetails.type === 'INTERNAL'}
                                        onChange={() => setGroupDetails({ ...groupDetails, type: 'INTERNAL' })}
                                        required
                                    />
                                    <Form.Check
                                        type="radio"
                                        inline
                                        label={t("External.label")}
                                        className="DataTypeCheck"
                                        name="typeck"
                                        id={`pageCheckbox-2`}
                                        checked={groupDetails.type === 'EXTERNAL'}
                                        onChange={() => setGroupDetails({ ...groupDetails, type: 'EXTERNAL' })}
                                        required
                                    />
                                </div>
                            </div>
                            <div className='col-md-2 p-2'>
                                <label className='mb-1'>
                                    {t("Weightage.label")}
                                    <OverlayTrigger
                                        placement="bottom"
                                        overlay={Utils.renderTooltip(t('WeightagePopupInfo.label'))}>
                                        <span className='font-18 ms-2'><BiInfoCircle /></span>
                                    </OverlayTrigger>
                                </label>
                                <input
                                    type="number"
                                    className="form-control"
                                    placeholder="%"
                                    value={groupDetails.weightage}
                                    onChange={(e) => setGroupDetails({ ...groupDetails, weightage: e.target.value })}
                                />
                            </div>
                            {/* <div className='col-md-2 p-2'>
                                <Button variant='GroupStake' className='btn-outline-primary border-0'>  <BiPlusCircle /></Button>
                            </div> */}
                        </div>
                        <div className='p-2 pt-3 text-center'>
                            <Button variant="secondary" className='px-4 me-2' onClick={handleAddGroupClose}>
                                {t("Close.label")}
                            </Button>
                            {
                                updateType == '' &&
                                <Button variant="primary" className='px-4' onClick={(e) => upsertStakeHoldersGroup(e)}>
                                    {t("Save.label")}
                                </Button>
                            }
                            {
                                updateType == 'EDIT_GROUP' &&
                                <Button variant="primary" className='px-4' onClick={(e) => updateStakeHolderGroup(e)}>
                                    {t("Update.label")}
                                </Button>
                            }
                        </div>
                    </Form>
                </Modal.Body>
            </Modal>

            {renderAddStakeholderModal()}

            {
                showConfirmation &&
                <ConfirmationModal
                    type={'Double_Materiality'}
                    modalShow={true}
                    messageText={t("StakeholderNoData.label")}
                    callbackModal={confirmCopy}
                    confirmBtn={t("Confirm.label")}
                    CancelBtn={t("Cancel.label")}
                />
            }

            {
                showDeleteConfirmation &&
                <ConfirmationModal
                    type={'Double_Materiality'}
                    modalShow={true}
                    messageText={t("ConfirmDelete.label")}
                    callbackModal={confirmDelete}
                    confirmBtn={t("Confirm.label")}
                    CancelBtn={t("Cancel.label")}
                />
            }

            {
                (showSaveAndProceedConfirmation.saveSelectedStakeholders) &&
                <ConfirmationModal
                    type={'Double_Materiality'}
                    modalShow={true}
                    messageText={t("SaveSelectedStakeholders.label")}
                    callbackModal={processMapping}
                    confirmBtn={t('Save.label')}
                    CancelBtn={t("Cancel.label")}
                />
            }

            {
                (showSaveAndProceedConfirmation.proceedToMatIssues) &&
                <ConfirmationModal
                    type={'Double_Materiality'}
                    modalShow={true}
                    title={t('ProceedToMatIssuesTitle.label')}
                    messageText={t("ProceedToMatIssues.label")}
                    callbackModal={navigateToMatIssues}
                    confirmBtn={t("Proceed.label")}
                    CancelBtn={t("DoItLater.label")}
                />
            }

            {
                showPrompt && <ConfirmationModal
                    type={'Double_Materiality'}
                    modalShow={showPrompt}
                    messageText={t("NavigateWarningText.label")}
                    callbackModal={(yes) => {
                        if (yes) {
                            confirmNavigation();
                        } else {
                            cancelNavigation();
                        }
                    }}
                    confirmBtn={t("Yes.label")}
                    CancelBtn={t("No.label")}
                />
            }
        </div >
    )
};

export default withTranslation()(Stakeholders);